import { render, staticRenderFns } from "./ReferralsCrudIndex.vue?vue&type=template&id=f9283ba0&scoped=true&"
import script from "./ReferralsCrudIndex.vue?vue&type=script&lang=js&"
export * from "./ReferralsCrudIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsCrudIndex.vue?vue&type=style&index=0&id=f9283ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9283ba0",
  null
  
)

export default component.exports